import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosError, AxiosResponse } from 'axios'
import { useState, useEffect } from 'react'

export interface TransformedAdvanceData {
  id: string
  title: string
  type: string
  time: Date
  value: number
  valueRaw: number
  description: string
  price: number
}
export interface TransformedWithdrawData {
  id: string
  title: string
  type: string
  time: Date
  value: number
  valueRaw: number
  description: string
  status: string
  info: string
  receiptUrl: string
  withdrawRawData: {
    agency: string
    bank: string
    nationalRegistration: string
    accountIdentifier: string
    accountType: string
    accountOwner: string
    description: string
    accountFullNumber: string
  }
}
export interface TransformedTransactions {
  withdraw: TransformedWithdrawData[]
  advance: TransformedAdvanceData[]
}
export interface FinancialTransactionsDataResponseParams {
  withdrawTotal: {
    formatedTotal: string
    rawValue: number
  }
  transactionsArray: TransformedTransactions
}

export interface FinancialTransactionsResponseParams {
  success: boolean
  data: FinancialTransactionsDataResponseParams
}

export interface useFinancialCloseTransactions {
  financialTransactions:
    | AxiosResponse<FinancialTransactionsResponseParams>
    | undefined
  isLoadingTransactions: boolean
  isErrorTransactions: AxiosError
}

export const useSWRRequest = (
  eventId: number
): useFinancialCloseTransactions => {
  const url: string = `producer/analytics/finacialCloseTransactions?eventId=${eventId}`

  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR(url, fetchData, {
    refreshInterval: 600000,
  })

  return {
    financialTransactions: data,
    isLoadingTransactions: isLoading,
    isErrorTransactions: error,
  }
}

export interface TransactionsProps {
  transactionsData: TransformedTransactions
  transactionsFormatedTotal: string
  transactionsRawTotal: number
  isLoading: boolean
  isErrorDebits: undefined | AxiosError
}

export const useFinancialClosingTransactions = (eventId: number): any => {
  const [transactions, setTransactions] = useState<TransactionsProps>({
    transactionsData: {
      withdraw: [],
      advance: [],
    },
    transactionsFormatedTotal: '',
    transactionsRawTotal: 0,
    isLoading: true,
    isErrorDebits: undefined,
  })

  const { financialTransactions, isLoadingTransactions, isErrorTransactions } =
    useSWRRequest(eventId)

  useEffect(() => {
    if (financialTransactions !== undefined) {
      const transactionsRaw = financialTransactions.data.data
      setTransactions({
        transactionsData: {
          withdraw: transactionsRaw.transactionsArray.withdraw,
          advance: transactionsRaw.transactionsArray.advance,
        },
        transactionsFormatedTotal: transactionsRaw.withdrawTotal.formatedTotal,
        transactionsRawTotal: transactionsRaw.withdrawTotal.rawValue,
        isLoading: isLoadingTransactions,
        isErrorDebits: isErrorTransactions,
      })
    }
  }, [financialTransactions, isLoadingTransactions, isErrorTransactions])

  return { transactions }
}
